import styled from 'styled-components';
export var FilterItem = styled.div.withConfig({
  displayName: "Filterstyles__FilterItem",
  componentId: "keen-query-creator__sc-861s91-0"
})(["&&&{max-width:60%;min-width:0;}"]);
export var Container = styled.div.withConfig({
  displayName: "Filterstyles__Container",
  componentId: "keen-query-creator__sc-861s91-1"
})(["&&&{display:flex;}&&& ", " + ", "{margin-left:5px;}&&& ", " + ", ":empty{display:none;}"], FilterItem, FilterItem, FilterItem, FilterItem);